<template lang="pug">
    section.app-main
        tags-view
        keep-alive(:include="cachedViews")
            router-view.body-container
</template>
<script>
import { mapState } from 'vuex';
import TagsView from './TagsView.vue';

export default {
    name: 'AppMain',
    components: {
        TagsView,
    },
    computed: {
        ...mapState('tagsView', {
            cachedViews: state => state.cachedViews,
        }),
    },
};
</script>
<style scoped lang="scss">
    .body-container {
        width: 100%;
        max-height: calc(100% - 32px);
        overflow-x: hidden;
        @include bg_color(color_base_background);
        // overflow-y: scroll;
    }
</style>
